import { ApolloClient, ApolloProvider, HttpLink } from "@apollo/client";
import { ReactNode } from "react";
import { useLocale } from "@amzn/xb-hooks";
import { useGetApolloClient } from "./useGetApolloClient";
import { useConfig } from "../../hooks";
import { getApolloClientCache } from "./ApolloClientCache";

export interface ApolloClientProviderConfig {
  apolloAppUri: string;
}

export const ApolloClientProvider = ({
  children,
  apolloClientLegacy,
}: {
  children: ReactNode;
  apolloClientLegacy?: boolean;
}) => {
  const { isLoading, locale } = useLocale();
  const { apolloAppUri } = useConfig();
  const client = useGetApolloClient();

  const httpLink = new HttpLink({
    uri: apolloAppUri as string,
    credentials: "include",
    preserveHeaderCase: true,
    fetch,
    headers: { ...(locale?.code && { "x-locale": locale.code }) },
  });

  // THIS IS NOT GOOD! It causes tons of re-renders and cancelled Graphql requests. Please remove.
  const legacyClient =
    apolloClientLegacy === true
      ? new ApolloClient({
          cache: getApolloClientCache(),
          link: httpLink,
        })
      : undefined;

  if (isLoading) {
    // TODO - return a loading spinner provided by the XBOSified app!
    return null;
  }

  return <ApolloProvider client={legacyClient ?? client}>{children}</ApolloProvider>;
};
